import { DropsListItemPlaceholder, } from 'root/src/client/v2/_pages/drops/components/DropsListItemPlaceholder';
import Link from 'next/link';
import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls';
import { memo } from 'react';
import { DropEventListContextProvider, } from 'root/src/client/v2/_pages/drops/contexts/dropEventList.context';
import { DropsListItem } from 'root/src/client/v2/_pages/drops/components/DropsListItem';
import { twMerge } from 'tailwind-merge';
import { useHashParam } from 'root/src/client/v2/common/hooks/useHashParam';
export const DropsList = memo((props) => {
    const [highlightedDrop] = useHashParam('drop');
    const { drops, isLoading, className, isOnboarding } = props;
    return (<ul className={twMerge('flex flex-wrap justify-center p-0 gap-6 sm:p-8', className)}>
			{isLoading && (<DropsListItemPlaceholder />)}
			{drops.map((dropEvent) => {
            const isHighlighted = isOnboarding && highlightedDrop === dropEvent.mnemonicId;
            return (<DropEventListContextProvider dropEvent={dropEvent} key={dropEvent.id}>
						<li>
							<Link href={{
                    pathname: routeUrls.drop(dropEvent.mnemonicId),
                    query: isOnboarding ? {
                        onboarding: isOnboarding,
                    } : undefined,
                }} passHref>
								<a className={twMerge(isHighlighted && 'flex rounded-3xl border-[6px] border-teal')} data-mnemonic-id={dropEvent.mnemonicId}>
									<DropsListItem />
								</a>
							</Link>
						</li>
					</DropEventListContextProvider>);
        })}
		</ul>);
});
